// WATER TANKER--------------------
export const FETCH_PURCHASE_INIT_ACTION = "FETCH_PURCHASE_INIT_ACTION";
export const FETCH_PURCHASE_SUCCESS_ACTION =
  FETCH_PURCHASE_INIT_ACTION + "_SUCCESS";
export const FETCH_PURCHASE_FAIL_ACTION = FETCH_PURCHASE_INIT_ACTION + "_ERROR";

export const ADD_WATERTANKER_INIT_ACTION = "ADD_WATERTANKER_INIT_ACTION";
export const ADD_WATERTANKER_SUCCESS_ACTION =
  ADD_WATERTANKER_INIT_ACTION + "_SUCCESS";
export const ADD_WATERTANKER_FAIL_ACTION =
  ADD_WATERTANKER_INIT_ACTION + "_ERROR";

export const UPDATE_WATERTANKER_INIT_ACTION = "UPDATE_WATERTANKER_INIT_ACTION";
export const UPDATE_WATERTANKER_SUCCESS_ACTION =
  UPDATE_WATERTANKER_INIT_ACTION + "_SUCCESS";
export const UPDATE_WATERTANKER_FAIL_ACTION =
  UPDATE_WATERTANKER_INIT_ACTION + "_ERROR";

export const DELETE_WATERTANKER_INIT_ACTION = "DELETE_WATERTANKER_INIT_ACTION";
export const DELETE_WATERTANKER_SUCCESS_ACTION =
  DELETE_WATERTANKER_INIT_ACTION + "_SUCCESS";
export const DELETE_WATERTANKER_FAIL_ACTION =
  DELETE_WATERTANKER_INIT_ACTION + "_ERROR";

// MUNCIPAL WATER---------------------

export const FETCH_MUNCIPAL_WATER_INIT_ACTION =
  "FETCH_MUNCIPAL_WATER_INIT_ACTION";
export const FETCH_MUNCIPAL_WATER_SUCCESS_ACTION =
  FETCH_MUNCIPAL_WATER_INIT_ACTION + "_SUCCESS";
export const FETCH_MUNCIPAL_WATER_FAIL_ACTION =
  FETCH_MUNCIPAL_WATER_INIT_ACTION + "_ERROR";

export const ADD_MUNCIPAL_WATER_INIT_ACTION = "ADD_MUNCIPAL_WATER_INIT_ACTION";
export const ADD_MUNCIPAL_WATER_SUCCESS_ACTION =
  ADD_MUNCIPAL_WATER_INIT_ACTION + "_SUCCESS";
export const ADD_MUNCIPAL_WATER_FAIL_ACTION =
  ADD_MUNCIPAL_WATER_INIT_ACTION + "_ERROR";

export const UPDATE_MUNCIPAL_WATER_INIT_ACTION =
  "UPDATE_MUNCIPAL_WATER_INIT_ACTION";
export const UPDATE_MUNCIPAL_WATER_SUCCESS_ACTION =
  UPDATE_MUNCIPAL_WATER_INIT_ACTION + "_SUCCESS";
export const UPDATE_MUNCIPAL_WATER_FAIL_ACTION =
  UPDATE_MUNCIPAL_WATER_INIT_ACTION + "_ERROR";

export const DELETE_MUNCIPAL_WATER_INIT_ACTION =
  "DELETE_MUNCIPAL_WATER_INIT_ACTION";
export const DELETE_MUNCIPAL_WATER_SUCCESS_ACTION =
  DELETE_MUNCIPAL_WATER_INIT_ACTION + "_SUCCESS";
export const DELETE_MUNCIPAL_WATER_FAIL_ACTION =
  DELETE_MUNCIPAL_WATER_INIT_ACTION + "_ERROR";

// RAIN WATER--------------------

export const FETCH_RAIN_WATER_PURCHASE_INIT_ACTION =
  "FETCH_RAIN_WATER_PURCHASE_INIT_ACTION";
export const FETCH_RAIN_WATER_PURCHASE_SUCCESS_ACTION =
  FETCH_RAIN_WATER_PURCHASE_INIT_ACTION + "_SUCCESS";
export const FETCH_RAIN_WATER_PURCHASE_FAIL_ACTION =
  FETCH_RAIN_WATER_PURCHASE_INIT_ACTION + "_ERROR";

export const ADD_RAIN_WATER_PURCHASE_INIT_ACTION =
  "ADD_RAIN_WATER_PURCHASE_INIT_ACTION";
export const ADD_RAIN_WATER_PURCHASE_SUCCESS_ACTION =
  ADD_RAIN_WATER_PURCHASE_INIT_ACTION + "_SUCCESS";
export const ADD_RAIN_WATER_PURCHASE_FAIL_ACTION =
  ADD_RAIN_WATER_PURCHASE_INIT_ACTION + "_ERROR";

export const UPDATE_RAIN_WATER_PURCHASE_INIT_ACTION =
  "UPDATE_RAIN_WATER_PURCHASE_INIT_ACTION";
export const UPDATE_RAIN_WATER_PURCHASE_SUCCESS_ACTION =
  UPDATE_RAIN_WATER_PURCHASE_INIT_ACTION + "_SUCCESS";
export const UPDATE_RAIN_WATER_PURCHASE_FAIL_ACTION =
  UPDATE_RAIN_WATER_PURCHASE_INIT_ACTION + "_ERROR";

export const DELETE_RAIN_WATER_PURCHASE_INIT_ACTION =
  "DELETE_RAIN_WATER_PURCHASE_INIT_ACTION";
export const DELETE_RAIN_WATER_PURCHASE_SUCCESS_ACTION =
  DELETE_RAIN_WATER_PURCHASE_INIT_ACTION + "_SUCCESS";
export const DELETE_RAIN_WATER_PURCHASE_FAIL_ACTION =
  DELETE_RAIN_WATER_PURCHASE_INIT_ACTION + "_ERROR";

// GROUND WATER-------------------------

export const FETCH_GROUND_WATER_PURCHASE_INIT_ACTION =
  "FETCH_GROUND_WATER_PURCHASE_INIT_ACTION";
export const FETCH_GROUND_WATER_PURCHASE_SUCCESS_ACTION =
  FETCH_GROUND_WATER_PURCHASE_INIT_ACTION + "_SUCCESS";
export const FETCH_GROUND_WATER_PURCHASE_FAIL_ACTION =
  FETCH_GROUND_WATER_PURCHASE_INIT_ACTION + "_ERROR";

export const ADD_GROUND_WATER_PURCHASE_INIT_ACTION =
  "ADD_GROUND_WATER_PURCHASE_INIT_ACTION";
export const ADD_GROUND_WATER_PURCHASE_SUCCESS_ACTION =
  ADD_GROUND_WATER_PURCHASE_INIT_ACTION + "_SUCCESS";
export const ADD_GROUND_WATER_PURCHASE_FAIL_ACTION =
  ADD_GROUND_WATER_PURCHASE_INIT_ACTION + "_ERROR";

export const UPDATE_GROUND_WATER_PURCHASE_INIT_ACTION =
  "UPDATE_GROUND_WATER_PURCHASE_INIT_ACTION";
export const UPDATE_GROUND_WATER_PURCHASE_SUCCESS_ACTION =
  UPDATE_GROUND_WATER_PURCHASE_INIT_ACTION + "_SUCCESS";
export const UPDATE_GROUND_WATER_PURCHASE_FAIL_ACTION =
  UPDATE_GROUND_WATER_PURCHASE_INIT_ACTION + "_ERROR";

export const DELETE_GROUND_WATER_PURCHASE_INIT_ACTION =
  "DELETE_GROUND_WATER_PURCHASE_INIT_ACTION";
export const DELETE_GROUND_WATER_PURCHASE_SUCCESS_ACTION =
  DELETE_GROUND_WATER_PURCHASE_INIT_ACTION + "_SUCCESS";
export const DELETE_GROUND_WATER_PURCHASE_FAIL_ACTION =
  DELETE_GROUND_WATER_PURCHASE_INIT_ACTION + "_ERROR";

export const FETCH_PURCHASE_DATA_INIT_ACTION =
  "FETCH_PURCHASE_DATA_INIT_ACTION";
export const FETCH_PURCHASE_DATA_SUCCESS_ACTION =
  FETCH_PURCHASE_DATA_INIT_ACTION + "_SUCCESS";
export const FETCH_PURCHASE_DATA_FAIL_ACTION =
  FETCH_PURCHASE_DATA_INIT_ACTION + "_ERROR";

export const ADD_PURCHASE_DATA_INIT_ACTION = "ADD_PURCHASE_DATA_INIT_ACTION";
export const ADD_PURCHASE_DATA_SUCCESS_ACTION =
  ADD_PURCHASE_DATA_INIT_ACTION + "_SUCCESS";
export const ADD_PURCHASE_DATA_FAIL_ACTION =
  ADD_PURCHASE_DATA_INIT_ACTION + "_ERROR";

export const FETCH_DATE_METER_READING_INIT_ACTION =
  "FETCH_DATE_METER_READING_INIT_ACTION";
export const FETCH_DATE_METER_READING_SUCCESS_ACTION =
  FETCH_DATE_METER_READING_INIT_ACTION + "_SUCCESS";
export const FETCH_DATE_METER_READING_FAIL_ACTION =
  FETCH_DATE_METER_READING_INIT_ACTION + "_ERROR";

export const GET_SOURCE_ENTRY_DATA_INIT_ACTION =
  "GET_SOURCE_ENTRY_DATA_INIT_ACTION";
export const GET_SOURCE_ENTRY_DATA_SUCCESS_ACTION =
  GET_SOURCE_ENTRY_DATA_INIT_ACTION + "_SUCCESS";
export const GET_SOURCE_ENTRY_DATA_FAIL_ACTION =
  GET_SOURCE_ENTRY_DATA_INIT_ACTION + "_ERROR";

export const CLEAR_WATER_PURCHASE_DATA = "CLEAR_WATER_PURCHASE_DATA";
